export default class RequirementController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirement/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirement/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/requirement/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirement/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirement/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirement/delete', 'post', params, axiosOption, httpOption);
  }

  static appoint (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirement/appoint', 'post', params, axiosOption, httpOption);
  }

  static startOnlyFlowRequirementAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirement/startOnly/flowRequirementAudit', 'post', params, axiosOption, httpOption);
  }

  static startWithBusinessKeyFlowRequirementAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirement/startWithBusinessKey/flowRequirementAudit', 'post', params, axiosOption, httpOption);
  }

  static startAndTakeUserTaskFlowRequirementAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirement/startAndTakeUserTask/flowRequirementAudit', 'post', params, axiosOption, httpOption);
  }

  static startAndSaveDraftFlowRequirementAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirement/startAndSaveDraft/flowRequirementAudit', 'post', params, axiosOption, httpOption);
  }

  static submitUserTaskFlowRequirementAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirement/submitUserTask/flowRequirementAudit', 'post', params, axiosOption, httpOption);
  }

  static viewTaskBusinessDataFlowRequirementAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirement/viewTaskBusinessData/flowRequirementAudit', 'get', params, axiosOption, httpOption);
  }

  static viewHistoricTaskBusinessDataFlowRequirementAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirement/viewHistoricTaskBusinessData/flowRequirementAudit', 'get', params, axiosOption, httpOption);
  }

  static listWorkOrderFlowRequirementAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirement/listWorkOrder/flowRequirementAudit', 'post', params, axiosOption, httpOption);
  }
}
